var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-0 col" }, [
    _c("div", { staticClass: "mb-2 posts-settings" }, [
      _c("div", { staticClass: "edit-section post-behaviour-editor mb-2" }, [
        !_vm.basic && false
          ? _c("div", { staticClass: "flexed mb-3" }, [
              _c("div", { staticClass: "campaign-manipulators" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover",
                        modifiers: { hover: true }
                      }
                    ],
                    staticClass: "btn top-action-btn",
                    attrs: { title: _vm.$t("Button.duplicate") },
                    on: { click: _vm.duplicateMpe }
                  },
                  [_c("icon", { attrs: { name: "copy" } })],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "flexed mb-1" }, [
          _c("div", { staticClass: "campaign-group flexed" }, [
            _c("div", { staticClass: "campaign-label " }, [
              _vm._v(
                "\n            " + _vm._s(_vm.getCampaignLabel) + "\n          "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flexed mb-3" }, [
          !_vm.published
            ? _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c("input-date-time", {
                    attrs: {
                      variant: "standardInput",
                      inputName: "startsAt",
                      inputLabel: _vm.$t("MpeEditor.DateTime.postAt.label"),
                      inputValue: _vm.publishAt,
                      smaller: "",
                      slimmer: "",
                      inputPlaceholder: _vm.$t("Datetime.postAt"),
                      minDateTime: _vm.getCurrentDateTIme
                    },
                    on: { fieldUpdate: _vm.updateMpeScheduale }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-100" },
            [
              _c("input-date-time", {
                attrs: {
                  variant: "standardInput",
                  inputName: "expiresAt",
                  inputLabel: _vm.$t("MpeEditor.DateTime.expiresAt.label"),
                  inputValue: _vm.removeAt,
                  smaller: "",
                  slimmer: "",
                  inputPlaceholder: _vm.$t("Datetime.removeAt"),
                  minDateTime: _vm.getCurrentDateTIme
                },
                on: { fieldUpdate: _vm.updateMpeScheduale }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.basic && false
            ? _c(
                "div",
                [
                  _c("form-checkbox", {
                    staticClass: " padded",
                    attrs: { items: _vm.afterCampaignCheckboxes },
                    on: { fieldUpdate: _vm.updateAfterEvent }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.getEditSectionClass }, [_vm._t("post-content")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2 posts-settings clear" }, [
      _c("div", { staticClass: "edit-section post-behaviour-editor" }, [
        _c("div", { staticClass: "mt-3" }, [
          _c(
            "div",
            { staticClass: "mpe-save-discard" },
            [
              _c("input-button", {
                attrs: {
                  variant: "standardInput",
                  btnStyle: "remove-style",
                  hollow: "",
                  inputPlaceholder: _vm.$t("Button.cancel")
                },
                on: { click: _vm.discardChanges }
              }),
              _vm._v(" "),
              _c("input-button", {
                staticClass: "ml-3",
                attrs: {
                  variant: "standardInput",
                  btnStyle: "ok-style",
                  spinner: "",
                  dataLoading: _vm.saving,
                  dissabled: _vm.submitDisabled,
                  inputPlaceholder: _vm.$t("Button.save")
                },
                on: { click: _vm.saveChanges }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-737660c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-737660c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/formatter/Base.vue
// module id = null
// module chunks = 